import React from "react";
import { motion } from "framer-motion";

const services = [
  {
    title: "General House Cleaning",
    desc: "Comprehensive plumbing and water management solutions including water supply, drainage, storm water systems, rainwater harvesting, STP layouts, and hydro-pnuematic systems-designed as per NBC and statutory norms.",
    img: "https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=600&q=80" // General House Cleaning
  },
  {
    title: "Deep Cleaning",
    desc: "Routine cleaning of living spaces, including dusting, vacuuming, and surface cleaning",
    img: "https://images.unsplash.com/photo-1464983953574-0892a716854b?auto=format&fit=crop&w=600&q=80" // Deep Cleaning
  },
  {
    title: "Move-In/Move-Out Cleaning",
    desc: "Routine cleaning of living spaces, including dusting, vacuuming, and surface cleaning",
    img: "https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?auto=format&fit=crop&w=600&q=80" // Move-In/Move-Out Cleaning
  },
  {
    title: "Post-Construction Cleaning",
    desc: "Routine cleaning of living spaces, including dusting, vacuuming, and surface cleaning",
    img: "https://images.unsplash.com/photo-1520880867055-1e30d1cb001c?auto=format&fit=crop&w=600&q=80" // Post-Construction Cleaning
  },
  {
    title: "Carpet and Upholstery Cleaning",
    desc: "Routine cleaning of living spaces, including dusting, vacuuming, and surface cleaning",
    img: "https://images.unsplash.com/photo-1465101046530-73398c7f28ca?auto=format&fit=crop&w=600&q=80" // Carpet and Upholstery Cleaning
  },
  {
    title: "Window Cleaning",
    desc: "Routine cleaning of living spaces, including dusting, vacuuming, and surface cleaning",
    img: "https://images.unsplash.com/photo-1482449609509-eae2a7ea42b7?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8d2luZG93JTIwY2xlYW5pbmd8ZW58MHx8MHx8fDA%3D" // Window Cleaning
  }
];

const ServicesList = ({ onDiscover }) => (
  <div style={{ background: "#fff", minHeight: "100vh", padding: "40px 0" }}>
    <h1 style={{ textAlign: "center", fontWeight: 700, fontSize: 48, marginBottom: 32 }}>Our services</h1>
    <div style={{
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(350px, 1fr))",
      gap: 32,
      maxWidth: 1200,
      margin: "0 auto"
    }}>
      {services.map((s, i) => (
        <motion.div
          key={i}
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: i * 0.15 }}
          style={{
            background: "#f5f5f5",
            borderRadius: 40,
            padding: 32,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            minHeight: 320,
            boxShadow: "0 2px 12px 0 rgba(0,0,0,0.03)",
          }}
        >
          <div>
            <h2 style={{ fontWeight: 700, fontSize: 24, marginBottom: 16 }}>{s.title}</h2>
            <p style={{ fontSize: 20, color: "#222", marginBottom: 24 }}>{s.desc}</p>
          </div>
          <img src={s.img} alt={s.title} style={{ width: "100%", maxWidth: 220, borderRadius: 24, alignSelf: "center" }} />
        </motion.div>
      ))}
    </div>
    <div style={{ textAlign: "center", marginTop: 48 }}>
      <button
        onClick={() => {
          console.log('Discover More clicked');
          if (onDiscover) onDiscover();
        }}
        style={{
          background: "#111827",
          color: "#fff",
          fontWeight: 600,
          fontSize: 20,
          border: "none",
          borderRadius: 32,
          padding: "16px 48px",
          cursor: "pointer",
          boxShadow: "0 2px 8px 0 rgba(0,0,0,0.08)",
          transition: "background 0.2s"
        }}
        onMouseOver={e => e.target.style.background = '#222b3a'}
        onMouseOut={e => e.target.style.background = '#111827'}
      >
        Discover More
      </button>
    </div>
  </div>
);

export default ServicesList;
